import React, { FC } from 'react';
import { Abbreviation, Date, Icon } from 'components/atoms';
import { useTerminologyConfig } from 'context/DataContext';
import {
  TimelineCardComponent,
  PerformedLabel,
  PerformedContainer,
  Time,
  Content,
  IconList,
} from './TimelineCard.styles';
import { TimelineCardProps } from './types';
import { ReactComponent as UnknownTypeIcon } from '../../../assets/svg/Icons/UnknownAudit.svg';
import { ThirdPartyType } from 'types';

const getThirdPartyIcon = (type) => {
  switch (type) {
    case ThirdPartyType.Individual:
      return <Icon icon="user" aria-hidden size="xxs" />;
    case ThirdPartyType.Business:
      return <Icon icon="company" aria-hidden size="xxs" />;
    default:
      return <UnknownTypeIcon aria-hidden />;
  }
};

const TimelineCard: FC<TimelineCardProps> = ({
  performedDate,
  content,
  dueDiligenceType,
  screeningId,
  auditEvent,
  type,
  name,
  performedBy,
}) => {
  const terminologyConfig = useTerminologyConfig();

  const parseAction = (action) => {
    if (action.includes('Third Party')) {
      return action.replace('Third Party', terminologyConfig?.thirdPartySingularNaming);
    }
    return action;
  };
  const action = parseAction(auditEvent);

  return (
    <TimelineCardComponent>
      <Time>
        <Date dateTime={performedDate} format="D MMMM, YYYY, HH:mm z" />
      </Time>
      <Content>
        <IconList>
          <li>
            <span style={{ height: '20px', display: 'inline-block' }}>
              {getThirdPartyIcon(type)}
            </span>
            {name}
          </li>
          {dueDiligenceType && (
            <li>
              <span>
                <Abbreviation abbreviation={dueDiligenceType.replace(/\s+/g, '')} outline small />
              </span>
              {dueDiligenceType}
              {content?.reportTemplate != null ? ' ' + content.reportTemplate : ''}
            </li>
          )}
          {action && (
            <li className="action">
              <span>
                <Icon icon="check" size="xxs" aria-hidden />
              </span>
              {action}
            </li>
          )}
          {screeningId && (
            <li className="action">
              <span></span>
              {dueDiligenceType.includes('Screening') ? 'Screening ID: ' : 'Report ID: '}
              {screeningId}
            </li>
          )}
          {content?.linkedThirdPartyInternalId && (
            <>
              <li className="content">
                {action.includes('Unlinked')
                  ? 'Unlinked Third Party ID: '
                  : 'Linked Third Party ID: '}
                <span className="internalId">{content.linkedThirdPartyInternalId}</span>
              </li>
              <li className="content">
                {'Relationship Type: '}
                <span className="internalId">
                  {content?.linkType != null ? content.linkType : '-'}
                </span>
              </li>
              <li className="content">
                <span></span>
                {'Percentage: '}
                {content?.percentage != null ? content.percentage + '%' : '-'}
              </li>
            </>
          )}
        </IconList>
        {performedBy && (
          <PerformedContainer>
            <PerformedLabel style={{ marginTop: '5px' }}>Performed by:</PerformedLabel>
            <PerformedLabel title={performedBy}>{performedBy}</PerformedLabel>
          </PerformedContainer>
        )}
      </Content>
    </TimelineCardComponent>
  );
};

export default TimelineCard;
